var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBattery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.625,
    height: 55.628,
    viewBox: "0 0 55.625 55.628",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(-10 -9.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M47.083,10H44.766V21.59H40.13V10H35.495V21.59H30.86V10H14.636A4.636,4.636,0,0,0,10,14.635V28.541a4.636,4.636,0,0,0,4.636,4.636H47.083a4.636,4.636,0,0,0,4.636-4.636V14.635A4.637,4.637,0,0,0,47.083,10ZM20.43,25.064a3.477,3.477,0,1,1,3.477-3.477A3.478,3.478,0,0,1,20.43,25.064Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M85.938,21.3H81.3V17.824l-4.635-1.159V30.571L81.3,29.413V25.936h4.636Z",
    transform: "translate(-20.312 -2.031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M30.86,63.9V59.27h7.5L43,50H37.813L35.5,54.634H30.86V50H16.953V63.905L10,68.54v4.636a4.635,4.635,0,0,0,4.636,4.635l25.5,0a4.636,4.636,0,0,0,4.636-4.636V68.54Z",
    transform: "translate(0 -12.187)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/battery.214fa8cfd30e9ee196ff44e834316e11.svg";
export { ForwardRef as ReactComponent };